import { Component, HostListener, Inject, OnInit } from '@angular/core';
import { ActivationEnd, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from "./components/header/header.component"
import { CommonModule } from '@angular/common';
import { DOCUMENT } from '@angular/common';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, FooterComponent, HeaderComponent, CommonModule],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent {
    title = 'Shriram Wealth';
    slug: any;
    scrollToTop: boolean = false;
    removeHeight: boolean = false;

    constructor(private router: Router, @Inject(DOCUMENT) private doc: Document) { }

    ngOnInit() {
        this.removeDefaultHeight();
        this.router.events.subscribe((event: any) => {
            if (event instanceof NavigationEnd) {
                this.removeDefaultHeight();
            }
            if (event instanceof ActivationEnd) {
                if (typeof window !== 'undefined') {
                    window.scrollTo(0, 0);
                }
            }
        });
    }

    removeDefaultHeight() {
        let currUrl = this.router.url.split('?')[0]
            .split('#')[0]
            .split('&')[0];
        let paths = currUrl.split('/');
        this.slug = paths.slice(-1)[0];
        let pageList = [
            'not-found'
        ];
        if (pageList.indexOf(this.slug) >= 0) {
            this.removeHeight = true;
        } else {
            this.removeHeight = false;
        }
    }

    @HostListener('window:scroll')
    onScroll() {
        // Scroll to Top
        if (typeof window != "undefined") {
            let scroll = window.scrollY;
            if (scroll > 700) {
                this.scrollToTop = true;
            } else {
                this.scrollToTop = false;
            }
        }
    }

    // Window Scroll to Top
    handler__scrollToTop() {
        if (typeof window !== "undefined") {
            window.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
        }
    }

    ngAfterViewInit() {
        //  setTimeout(() =>, 3000); // delay GTM load
    }


    initGTM() {
        if (typeof window !== 'undefined') {
            // --------------------------
            const scrtipt1 = this.doc.createElement("script");
            scrtipt1.id = "gtm-script";
            scrtipt1.async = true;
            scrtipt1.src = `https://www.googletagmanager.com/gtm.js?id=3SFFC0N8W9`;
            this.doc.head.appendChild(scrtipt1);

            // --------------------------
            const inlineScript = this.doc.createElement('script');
            inlineScript.innerHTML = `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '3SFFC0N8W9');
            `;
            this.doc.head.appendChild(inlineScript);
        }
    }
}
